import { useState } from 'react';
import Button from '@mui/material/Button';
import { useSnackbar } from 'notistack';
import apiClient from "../apiClient";
import { useExportJobs } from '../hooks/useExportJobs';


interface DownloadRawJsonProps {
  selectedRows?: string[];
  campaignId?: string;
  selectedNetworkType: string;
  styleOverrides?: React.CSSProperties;
  disabled?: boolean;
}

export default function DownloadRawJson({
  selectedRows,
  campaignId,
  selectedNetworkType,
  styleOverrides,
  disabled,
}: DownloadRawJsonProps) {

  const [isLoading, setLoading] = useState(false);

  const { enqueueSnackbar } = useSnackbar();
  const { watchJob, invalidateExportJobs } = useExportJobs();

  const handleClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    if ((!selectedRows || selectedRows.length === 0) && !campaignId) {
      enqueueSnackbar('Please select a dataset to request download', {
        variant: 'error',
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center'
        }
      });
      return;
    }
    try {
      setLoading(true);
      const { data } = await apiClient.post<{ job_id?: string }>(
        '/sigcap/api/request-collection-download/',
        {
          collection_ids: selectedRows,
          export_type: 'json',
        },
      );
      if (data.job_id) {
        watchJob(data.job_id);
      }
      invalidateExportJobs();
      enqueueSnackbar(
        'Export started. Track progress under Download Status in your account menu.',
        {
          variant: 'success',
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'center',
          },
        },
      );
    } catch (error) {
      enqueueSnackbar('Error submitting download request', {
        variant: 'error',
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center',
        },
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="contained"
      style={styleOverrides}
      disabled={isLoading || disabled}
      onClick={handleClick}
    >
      {isLoading ? 'Requesting…' : 'Download Raw JSON'}
    </Button>
  );
};
